import WitnessService from '@/hexapla-core/domains/resources/witnesses'
import WitnessTypeService from '@/hexapla-core/domains/resources/witness_types'
import { Witness, WitnessType } from '@/hexapla-core/domains/resources'

export interface UseWitnessService {
  listWitnesses: () => Promise<Witness[]>
  listWitnessTypes: () => Promise<WitnessType[]>
  showWitness: (id: number) => Promise<Witness>
  createWitness: (witness: Witness) => Promise<Witness>
  updateWitness: (witness: Witness) => Promise<Witness>
  deleteWitness: (id: number) => Promise<void>
}

export function useWitnessesService(url: string): UseWitnessService {
  return {
    listWitnesses: () => WitnessService.index(url),
    listWitnessTypes: () => WitnessTypeService.index(url),
    showWitness: (id: number) => WitnessService.show(url, id),
    createWitness: (witness: Witness) => WitnessService.create(url, witness),
    updateWitness: (witness: Witness) => WitnessService.update(url, witness),
    deleteWitness: (id: number) => WitnessService.destroy(url, id),
  }
}
